export const buildAtsCandidateLink = (candidateId: string, folderPath?: string | null): string => {
  const params = new URLSearchParams({ candidate: candidateId });
  const folder = folderPath?.trim();
  if (folder) {
    params.set('folder', folder);
  }
  return `/ats?${params.toString()}`;
};

export const parseAtsCandidateDeepLink = (search: string): {
  candidateId: string | null;
  folderPath: string | null;
  edit: boolean;
} => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  return {
    candidateId: params.get('candidate')?.trim() || null,
    folderPath: params.get('folder')?.trim() || null,
    edit: params.get('edit') === '1',
  };
};

export const resolveSelectedCandidateId = (
  currentId: string | null,
  pageItems: Array<{ candidate_id: string }>,
  keepWhenMissing = true,
): string | null => {
  if (currentId && (keepWhenMissing || pageItems.some((item) => item.candidate_id === currentId))) {
    return currentId;
  }
  return pageItems[0]?.candidate_id || null;
};

export const ensureSelectedCandidateInList = <T extends { candidate_id: string }>(
  items: T[],
  selectedId: string | null,
  selectedItem: T | null,
): T[] => {
  if (!selectedId) return items;
  if (items.some((item) => item.candidate_id === selectedId)) return items;
  if (selectedItem?.candidate_id === selectedId) {
    return [selectedItem, ...items];
  }
  return items;
};

export const selectedCandidatePin = (
  selectedId: string | null,
  selectedItem: { candidate_id: string; documents?: unknown[] } | null,
  folderPath: string | undefined,
  pageItems: Array<{ candidate_id: string }>,
  belongsToFolder: (item: { candidate_id: string; documents?: unknown[] }, folder: string) => boolean,
): { keepId: boolean; pinInList: boolean } => {
  if (!selectedId) return { keepId: false, pinInList: false };
  if (pageItems.some((item) => item.candidate_id === selectedId)) {
    return { keepId: true, pinInList: false };
  }
  if (!folderPath) {
    return {
      keepId: true,
      pinInList: selectedItem?.candidate_id === selectedId,
    };
  }
  if (!selectedItem || selectedItem.candidate_id !== selectedId) {
    return { keepId: true, pinInList: false };
  }
  const belongs = belongsToFolder(selectedItem, folderPath);
  return { keepId: belongs, pinInList: belongs };
};
